module.exports = __webpack_public_path__ + "img/st-brosur.1c1837f0.jpg";